import React, { useState } from 'react';
import ReactApexChart from "react-apexcharts";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Card, CardHeader, CardBody } from 'reactstrap';
import { FaDownload } from 'react-icons/fa';

import getChartColorsArray from './DynamicChartsColor';
import subscriptionDetailData from './fakedata/subscription_detail.json';

const downloadCSV = (data, headers, filename = 'data.csv') => {
    const csvRows = [];
    csvRows.push(headers.join(','));

    for (const row of data) {
        const values = headers.map(header => row[header] || '');
        csvRows.push(values.join(','));
    }

    const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};

const CreditUsageGraphic = ({ dataColors }) => {
    const [view, setView] = useState('weekly');
    const chartGroupbarColors = getChartColorsArray(dataColors);

    const monthlyUsage = subscriptionDetailData.monthlyUsage;
    const months = Object.keys(monthlyUsage);
    const weeks = ['Week 1', 'Week 2', 'Week 3', 'Week 4'];

    const series = view === 'weekly' ? weeks.map((week, index) => ({
        name: week,
        data: months.map(month => monthlyUsage[month][`week${index + 1}`])
    })) : [{
        name: 'Monthly Usage',
        data: months.map(month => Object.values(monthlyUsage[month]).reduce((a, b) => a + b, 0))
    }];

    const options = {
        chart: {
            type: 'bar',
            height: 500,
            toolbar: {
                show: false,
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                dataLabels: {
                    position: 'top',
                },
            }
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 1,
            colors: ['#fff']
        },
        tooltip: {
            shared: true,
            intersect: false
        },
        xaxis: {
            categories: months,
        },
        yaxis: {
            labels: {
                formatter: function (value) {
                    return value.toLocaleString();
                }
            }
        },
        colors: chartGroupbarColors
    };

    const handleDownload = () => {
        let data;
        let headers;

        if (view === 'weekly') {
            data = months.map(month => {
                const row = { Category: month };
                weeks.forEach((week, index) => {
                    row[week] = monthlyUsage[month][`week${index + 1}`];
                });
                return row;
            });
            headers = ['Category', ...weeks];
        } else {
            data = months.map((month, index) => ({
                Category: month,
                'Monthly Usage': series[0].data[index]
            }));
            headers = ['Category', 'Monthly Usage'];
        }

        downloadCSV(data, headers, 'chart_data.csv');
    };

    return (
        <React.Fragment>
            <Card>
                <CardHeader className="d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">
                        <b>Credit Usage Graphic</b>
                    </h4>
                    <UncontrolledDropdown className="card-header-dropdown">
                        <DropdownToggle tag="a" className="text-reset dropdown-btn" role="button">
                            <span className="fw-semibold text-uppercase fs-12">View by: </span>
                            <span className="text-muted">{view.charAt(0).toUpperCase() + view.slice(1)}<i className="mdi mdi-chevron-down ms-1"></i></span>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem onClick={() => setView('weekly')} className={view === 'weekly' ? 'active' : ''}>Weekly</DropdownItem>
                            <DropdownItem onClick={() => setView('monthly')} className={view === 'monthly' ? 'active' : ''}>Monthly</DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>

                    <UncontrolledDropdown style={{ paddingLeft: 10 }}>
                        <DropdownToggle tag="a" className="text-reset">
                            <FaDownload size={13} />
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={handleDownload}>Download CSV</DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>

                </CardHeader>

                <CardBody>
                    <ReactApexChart
                        dir="ltr"
                        className="apex-charts"
                        options={options}
                        series={series}
                        type="bar"
                        height={475}
                    />
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default CreditUsageGraphic;
